/** Name of the pickup-location search input, shared by the combobox and the keyboard navigation that targets it. */
export const PICKUP_POINT_INPUT_NAME = 'pickupLocation';
